// N38 · Phase 3.2 — 助手 TTS 朗读（SpeechSynthesis，默认开）
// 静音偏好持久化在 localStorage.checkinTtsMuted（数据字典已登记）。
// 朗读不挡确认：speak 是发后不管，新台词来了打断旧的。
//
// Chrome speechSynthesis 的几个经典坑，这里都绕过：
// ① cancel() 后同步 speak() 偶发被吞 → cancel 只在有话在说时调，speak 放进 setTimeout(0)
// ② 引擎偶发卡 paused 态（页面切后台回来）→ speak 前先 resume()
// ③ utterance 没引用会被 GC，话说一半静音 → 模块级持有当前 utterance
// ④ 声音表异步加载，首次 getVoices() 可能为空 → 提前订阅 voiceschanged 暖一次

const KEY = 'checkinTtsMuted';

let currentUtterance = null; // ③ 防 GC

// ④ 暖声音表：模块加载时就触发一次 getVoices + 订阅变更
try {
  if (window.speechSynthesis) {
    window.speechSynthesis.getVoices();
    window.speechSynthesis.onvoiceschanged = () => { window.speechSynthesis.getVoices(); };
  }
} catch (e) { /* ignore */ }

function pickZhVoice() {
  try {
    const vs = window.speechSynthesis.getVoices() || [];
    return vs.find(v => /^zh([-_]|$)/i.test(v.lang)) || null;
  } catch (e) { return null; }
}

export function isTtsMuted() {
  try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
}

export function setTtsMuted(muted) {
  try { localStorage.setItem(KEY, muted ? '1' : '0'); } catch (e) { /* 存不上就只管本次 */ }
  if (muted) stopSpeaking();
}

export function stopSpeaking() {
  try { window.speechSynthesis && window.speechSynthesis.cancel(); } catch (e) { /* ignore */ }
}

// force=true：手动点某条气泡的喇叭重播——明确手势，无视全局静音
export function speak(text, force = false) {
  if (!force && isTtsMuted()) return;
  try {
    const synth = window.speechSynthesis;
    if (!synth || typeof SpeechSynthesisUtterance === 'undefined') return;
    // 符号/emoji 不念，念出来很怪
    const clean = String(text).replace(/[✓⚠📍📝🧠💬～~「」【】·]/g, ' ').replace(/\s+/g, ' ').trim();
    if (!clean) return;
    const u = new SpeechSynthesisUtterance(clean);
    const v = pickZhVoice();
    if (v) { u.voice = v; u.lang = v.lang; } else { u.lang = 'zh-CN'; }
    u.onerror = (e) => { try { console.warn('[打卡助手 TTS]', (e && e.error) || e); } catch (e2) { /* ignore */ } };
    currentUtterance = u; // ③
    if (synth.speaking || synth.pending) synth.cancel(); // ① 只在必要时打断
    synth.resume(); // ②
    setTimeout(() => {
      try { synth.speak(currentUtterance); } catch (e) { /* ignore */ }
    }, 0); // ① cancel→speak 不同步
  } catch (e) { /* TTS 不可用（老 Safari 等）：静默降级，不影响打卡 */ }
}
